import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import CRMApi from '../../../Api/CRM/CRMApi';
import GetDictionaryResponse from '../../../Api/CRM/Responses/DictionaryResponse';
import MenuItem from '../../../Api/Models/MenuItem';
import TrueFalseIcon from '../../../components/common/TrueFalseIcon';
import Card from '../../elements/common/Card';
import Row, { TableDetailsBody } from '../../elements/common/TableDetailsRow';
import useNumberParams from '../../hooks/useNumberParams';
import useOnce from '../../hooks/useOnce';

export default function MenuItemDetails() {
    const { id } = useNumberParams();
    const [menuItem, setMenuItem] = useState<MenuItem>({} as MenuItem);
    const [menuList, setMenuList] = useState<GetDictionaryResponse>({});
    const [parentList, setParentList] = useState<GetDictionaryResponse>({});

    useOnce(() => {
        CRMApi.menuItems.getById(id).then((item) => {
            if (item.parent_id > 0) {
                CRMApi.menus.getMenuItemNames(item.menu_id).then(setParentList);
            }
            setMenuItem(item);
        });
        CRMApi.menus.getNames().then(setMenuList);
    });

    return (
        <Card>
            <TableDetailsBody>
                <Row label="ID">{menuItem.id}</Row>
                <Row label="Order">{menuItem.order}</Row>
                <Row label="Name">{menuItem.name}</Row>
                <Row label="Class">{menuItem.class}</Row>
                <Row label="No follow">
                    <TrueFalseIcon status={menuItem.rel_nofollow} />
                </Row>
                <Row label="Menu">
                    <Link to={`/menus/${menuItem.menu_id}`}>{menuList[menuItem.menu_id]}</Link>
                </Row>
                <Row label="Parent Item">{parentList[menuItem.parent_id]}</Row>
            </TableDetailsBody>
            <Link to={`/menu_items/${id}/update`} className="btn btn-default right">
                Edit Menu Item
            </Link>
        </Card>
    );
}
